function mergeId(...ids: string[]) {
  return ids.join("-");
}

export default mergeId;
